import themeUrl from '../../assets/audio/Main Theme.mp3';
import { mixer } from '../../audio/audio-mixer.js';

const FADE_OUT_MS = 1500;

/** Loops the main theme behind the lobby and fades it out once the party lands in the world. */
export class ThemeMusic {
  private readonly track = mixer.engine.stream(themeUrl, 'music');
  private readonly audio = this.track.element;
  /** The theme's own level (0..1); the music bus applies the player's music volume on top. */
  private level = 0;
  private wanted = false;
  private fade: ReturnType<typeof setInterval> | undefined;

  constructor() {
    this.audio.preload = 'auto'; this.audio.loop = true;
    // Browsers refuse sound until the page has been touched, so the first gesture starts a track that is already wanted.
    const unlock = () => { removeEventListener('pointerdown', unlock); removeEventListener('keydown', unlock); if (this.wanted) this.start(); };
    addEventListener('pointerdown', unlock); addEventListener('keydown', unlock);
  }

  /** Plays from the lobby; harmless to call again while the theme is already running. */
  play() { this.wanted = true; this.start(); }

  /** Fades the theme out; the next `play` starts it again from where it stopped. */
  stop() {
    this.wanted = false; this.stopFade();
    const from = this.level, started = performance.now();
    this.fade = setInterval(() => {
      const progress = Math.min(1, (performance.now() - started) / FADE_OUT_MS);
      this.setLevel(from * (1 - progress));
      if (progress === 1) { this.stopFade(); this.audio.pause(); }
    }, 50);
  }

  private setLevel(level: number) { this.level = level; this.track.level(level); }

  private stopFade() { clearInterval(this.fade); this.fade = undefined; }

  private start() {
    this.stopFade();
    this.setLevel(1);
    this.audio.play().catch(() => { /* Blocked until a gesture; the unlock listener retries. */ });
  }
}
